import { Schema as ProductsSchema } from "@comparaonline/products-schema";
import { Schema as MarketplaceSchema } from "@comparaonline/marketplace-schema";

import { useAppContext } from "../../../../lib/appContext";
import { useRouter } from "../../../../lib/routerContext";

type ProductLandingParams = ProductsSchema.ProductDetailsBySlugQueryArgs &
  Pick<MarketplaceSchema.LandingQueryArgs, "path">;

export const useLandingInput = (): ProductLandingParams => {
  const {
    businessUnitConfig: { businessCode }
  } = useAppContext();
  const router = useRouter();
  const query = router && router.query;
  return {
    businessUnit: businessCode,
    divisionSlug: (query && (query.divisionSlug as string)) || "",
    path: router ? router.asPath : "",
    productSlug: (query && (query.productSlug as string)) || ""
  };
};
